const types = [
  {
    label: 'Объявление не актуально',
    value: 'not_relevant',
  },
  {
    label: 'Неверные данные',
    value: 'wrong_data',
  },
  {
    label: 'Дубликат',
    value: 'duplicate',
  },
  {
    label: 'Мошенничество',
    value: 'fraud',
  },
];

export default types;
